export const DownloadFileIcon = ({ className, onClick }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <g clipPath="url(#clip0_2078_8103)">
        <path
          d="M16.4844 17.5H5.23438C5.06861 17.5 4.90964 17.4342 4.79243 17.3169C4.67522 17.1997 4.60938 17.0408 4.60938 16.875V3.125C4.60938 2.95924 4.67522 2.80027 4.79243 2.68306C4.90964 2.56585 5.06861 2.5 5.23438 2.5H12.7344L17.1094 6.875V16.875C17.1094 17.0408 17.0435 17.1997 16.9263 17.3169C16.8091 17.4342 16.6501 17.5 16.4844 17.5Z"
          stroke="#070707"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.7344 2.5V6.875H17.1094"
          stroke="#070707"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.8594 9.375V14.375"
          stroke="#070707"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.98438 12.5L10.8594 14.375L12.7344 12.5"
          stroke="#070707"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2078_8103">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.859375)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
